// Lib
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

// Hooks
import useSideMenu from '../../../hooks/useSideMenu';
import useAuth from '../../../pages/Auth/hooks/useAuth';
import useSearch from '../../../hooks/useSearch';
import useCart from '../../../pages/Cart/hooks/useCart';
import useUI from '../../../hooks/useUI';

// Constants
import {
  DESKTOP_HEADER_LINKS,
  MOBILE_HEADER_LINKS,
} from '../../../constants/header';
import { SSO_LOGIN_PAGE, HOME_PAGE } from '../../../constants/urls';

// Styles
import { useStyles } from './HeaderStyles';

const getLogoPath = ({ isSsoLogoutPage, isAuthPage, isLoggedIn }) => {
  if (isSsoLogoutPage) {
    return '/';
  }
  if (isAuthPage) {
    return '/auth';
  }
  return isLoggedIn ? HOME_PAGE : SSO_LOGIN_PAGE;
};

const useHeader = ({
  isKiteUser,
  isAuthPage,
  isLoggedIn,
  onlyLogoLink,
  onlyContent,
}) => {
  const { isDesktopMode, isTabletMode, isMobileMode } = useUI();
  const { pathname } = useLocation();
  const {
    isActive: isActiveSearch,
    onToggleSearchInput,
    onChange,
    searchValue,
    onClearSearch,
  } = useSearch();
  const { classes, cx } = useStyles({
    isKiteUser,
    isAuthPage,
    onlyContent,
    onlyLogoLink,
    isActiveSearch,
  });
  const { totalCountInCart } = useCart();

  const { active, toggleSideMenu, onCloseSideMenu } = useSideMenu();
  const { onLogout } = useAuth();

  const HEADER_LINKS = useMemo(
    () => (isDesktopMode ? DESKTOP_HEADER_LINKS : MOBILE_HEADER_LINKS),
    [isDesktopMode],
  );

  const isSsoLogoutPage = useMemo(
    () => pathname.includes('sso/logout'),
    [pathname],
  );

  const logoPath = useMemo(
    () => getLogoPath({ isSsoLogoutPage, isAuthPage, isLoggedIn }),
    [isSsoLogoutPage, isAuthPage, isLoggedIn],
  );

  return {
    classes,
    cx,
    isDesktopMode,
    isTabletMode,
    isMobileMode,
    pathname,
    isActiveSearch,
    onToggleSearchInput,
    onChange,
    searchValue,
    onClearSearch,
    totalCountInCart,
    active,
    toggleSideMenu,
    onCloseSideMenu,
    onLogout,
    HEADER_LINKS,
    logoPath,
  };
};

export default useHeader;
